import type { SVGProps } from 'react';
const SvgViewComfy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_comfy_svg__a)">
      <path
        fill="currentColor"
        d="M3 9h4V5H3v4Zm0 5h4v-4H3v4Zm5 0h4v-4H8v4Zm5 0h4v-4h-4v4ZM8 9h4V5H8v4Zm5-4v4h4V5h-4Zm5 9h4v-4h-4v4ZM3 19h4v-4H3v4Zm5 0h4v-4H8v4Zm5 0h4v-4h-4v4Zm5 0h4v-4h-4v4Zm0-14v4h4V5h-4Z"
      />
    </g>
    <defs>
      <clipPath id="view_comfy_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewComfy;
